import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ApiService } from '../../services/api.service';

@Component({
  selector: 'app-faq',
  templateUrl: './faq.component.html',
  styleUrl: './faq.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class FaqComponent implements OnInit {
  constructor(private readonly apiService: ApiService) {}

  showModal: boolean = false;
  content: any;
  modalUrl: string = '';

  ngOnInit(): void {
    this.getContent();
  }

  getContent(): void {
    this.apiService.getAemPage('Faq').subscribe(data => {
      this.content = data;
      this.modalUrl = data.modalButtonRoute;
    });
  }

  openModal(): void {
    this.showModal = true;
  }

  goToFaqSite(): void {
    window.open(this.modalUrl, '_blank');
  }
}
